// Shared contract status map — source of truth for UI labels + colors.
// Extracted into lib/ during Phase 45-03; consumed by AmbassadorRow + ContractCard.
// Phase 57-01: 'link_sent' inserted between 'draft' and 'form_sent'.
export const CONTRACT_STATUS = {
  draft:            { label: 'Черновик',         color: '#94a3b8', order: 0 },
  link_sent:        { label: 'Ожидаем данные',   color: '#f59e0b', order: 1 },
  form_sent:        { label: 'Форма отправлена', color: '#38bdf8', order: 2 },
  submitted:        { label: 'Заполнено',        color: '#a855f7', order: 3 },
  reviewing:        { label: 'Проверка',         color: '#f59e0b', order: 4 },
  sent_to_sign:     { label: 'На подписи',       color: '#3b82f6', order: 5 },
  sent_to_docusign: { label: 'На подписи',       color: '#3b82f6', order: 5 },
  completed:        { label: 'Завершён',         color: '#10b981', order: 6 },
  terminated:       { label: 'Расторгнут',       color: '#ef4444', order: 7 },
};

// 'terminated' — это ПОСЛЕ-подписное состояние: подписанный договор никуда не
// девается (нужен для налоговой/юр. истории), поэтому UI-ветка «документы»
// (скачать PDF / Dropbox / ссылка) общая для completed и terminated.
export const isSignedContract = (status) => status === 'completed' || status === 'terminated';
